// extracted by mini-css-extract-plugin
export var growableInput = "_70-0";
export var tagContainer = "_70-2";
export var textInput = "_70-1";